import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import {AuthService} from './auth.service';
import {SettingsService} from '../common/settings.service';
import 'rxjs/add/operator/map';

@Injectable()
export class SettingsListService {

  constructor(
    private http: Http,
    private authService: AuthService,
    private settings: SettingsService,
  ) { }

  getAllSettings() {
    const headers = new Headers();
    headers.append('LoginRole', 'Administrator');
    headers.append('Authorization', this.authService.getUserToken());

    return this.http.get(this.settings.serverNomenclator + 'Setting/ReadAll', {headers: headers})
      .map(res => res.json());
  }
  editSetting(edit) {
    const headers = new Headers();
    headers.append('LoginRole', 'Administrator');
    headers.append('Authorization', this.authService.getUserToken());

    return this.http.post(this.settings.serverNomenclator + 'Setting/Put', edit, {headers: headers})
      .map(res => res.json());
  }

}
